<template>
    <div>
        <section class="basic-info">
            <v-container>
                <v-row v-if="loading">
                    <v-col cols="12" sm="6" offset-sm="3">
                        <v-card>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-progress-linear :indeterminate="true"></v-progress-linear>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row v-else-if="user">
                    <v-col cols="14" offset="1" sm="16" offset-sm="0">
                        <v-row>
                            <v-col cols="16" offset="0" md="8" offset-md="4" class="text-center">
                                <div class="user-detail-avatar">
                                    <user-avatar-view :settings="user.user.avatar" />
                                </div>
                                <h2 class="section-subtitle">{{user.user.nickname}}</h2>

                                <p v-if="user.user.cityId">{{ user.user.cityName }}</p>

                                <user-message-dialog v-if="canSendMessage" :recipient="user.user"></user-message-dialog>

                                <!--v-btn
                                    v-if="user.team !== null"
                                    color="primary"
                                    dark
                                    :to="{ name: 'teamDetail', params: { id: user.team.id } }"
                                >
                                    <v-icon left>mdi-account-supervisor</v-icon>
                                    {{ user.team.name }}
                                </v-btn-->
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section v-if="loading === false && user && user.team" class="order order--membership">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" sm="16" offset-sm="0">
                        <h2 class="section-subtitle">Členství v týmu</h2>
                        <v-row>
                            <v-col cols="16" offset="0" sm="12" offset-sm="2">
                                <v-data-table
                                    :headers="headers"
                                    :items="[user.team]"
                                    :hide-default-footer="true"
                                    :items-per-page="5"
                                    class="transparent"
                                >
                                    <template v-slot:item.name="{ item }">
                                        <div class="order__flex">
                                            <team-blazon-view :settings="item.blazon" class="small" />
                                            <span>{{ item.name }}</span>
                                        </div>
                                    </template>
                                    <template v-slot:item.players="{ item }">
                                        {{ item.players }}&nbsp;hráčů
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <div class="team-members__flex">
                                            <v-btn dark large class="btn-without-border margintop0" icon
                                                   :to="{ name: 'teamDetail', params: { id: item.id } }">
                                                Detail týmu
                                            </v-btn>
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { GET_USER_DETAIL_REQUEST } from '../store/actions/user'
    import UserMessageDialog from '../components/Message/UserMessageDialog';
    import TeamBlazonView from '../components/TeamBlazon/TeamBlazonView';
    import UserAvatarView from '../components/UserAvatar/UserAvatarView';

    export default {
        components: {
            UserAvatarView,
            TeamBlazonView,
            UserMessageDialog,
        },
        props: {
            id: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                user: null,
                loading: false,
                headers: [
                    {
                        text: 'Členství v týmu',
                        value: 'name',
                    },
                    {
                        text: 'Hráčů v týmu',
                        value: 'players',
                    },
                    {
                        text: 'Akce',
                        sortable: false,
                        align: 'right',
                        width: 60,
                        value: 'action',
                    },
                ],
            };
        },
        computed: {
            canSendMessage () {
                return this.myUser.id !== this.user.user.id;
            },
            ...mapState({
                myUser: state => state.user.user,
            }),
        },
        async mounted () {
            try {
                this.loading = true;
                this.user = await this.$store.dispatch('user/' + GET_USER_DETAIL_REQUEST, { id: this.id });
            } catch (e) {
                this.$toast.error('Došlo k chybě při načítání detailu hráče. Zkuste to později.');
            } finally {
                this.loading = false;
            }
        },
    }
</script>
